import types from './types';

const INITIAL_STATE = {
  isUploading: false,
  isUploadingBatchClaimFiles: false,
  isFetching: false,
  isFetchingNo: false,
  isFetchingHistory: false,
  isFetchingAllHistory: false,
  isInserting: false,

  result: [],
};

const claimBatchReportsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.UPLOAD_BATCH_CLAIM_TEST_FILE_REQUEST:
      return {
        ...state,
        result: [],
        isUploading: true,
      };
  
    case types.UPLOAD_BATCH_CLAIM_TEST_FILE_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUploading: false,
      };
  
    case types.UPLOAD_BATCH_CLAIM_TEST_FILE_FAILURE:
      return {
        ...state,
        result: [],
        isUploading: false,
      };

    case types.UPLOAD_BATCH_CLAIM_FILES_REQUEST:
      return {
        ...state,
        result: [],
        isUploadingBatchClaimFiles: true,
      };
  
    case types.UPLOAD_BATCH_CLAIM_FILES_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isUploadingBatchClaimFiles: false,
      };
  
    case types.UPLOAD_BATCH_CLAIM_FILES_FAILURE:
      return {
        ...state,
        result: [],
        isUploadingBatchClaimFiles: false,
      };

    case types.GET_SUBMITTED_BATCH_REPORTS_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_SUBMITTED_BATCH_REPORTS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_SUBMITTED_BATCH_REPORTS_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.GET_CLAIM_BATCH_TEST_HISTORY_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingHistory: true,
      };

    case types.GET_CLAIM_BATCH_TEST_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingHistory: false,
      };

    case types.GET_CLAIM_BATCH_TEST_HISTORY_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingHistory: false,
      };

    case types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingAllHistory: true,
      };

    case types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingAllHistory: false,
      };

    case types.GET_ALL_CLAIM_BATCH_TEST_HISTORY_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingAllHistory: false,
      };

    case types.INSERT_CLAIM_BATCH_HEADER_REQUEST:
      return {
        ...state,
        result: [],
        isInserting: true,
      };

    case types.INSERT_CLAIM_BATCH_HEADER_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isInserting: false,
      };

    case types.INSERT_CLAIM_BATCH_HEADER_FAILURE:
      return {
        ...state,
        result: [],
        isInserting: false,
      };

    default:
      return state;
    }
};

export default claimBatchReportsReducer;
